import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { BroadcastService, LoaderService, MessageService, UserService } from '..';
import { Observable, retry, throwError, timer } from 'rxjs';
import { MsgConstantConfig } from '../config/message.constant.config';
import { PathConfig } from '../config/path.config';
import { AuthService } from '../services/auth-service';
import { ClientDetailService } from '../services/client-detail-service';
import { GlobalErrorHandler } from '../services/error.handler.service';
import { SessionExpiredService } from '../services/session-expired.service';

@Injectable()
export class HttpInterceptorClass implements HttpInterceptor {
  private readonly retryableStatuses = [0, 408, 502, 503, 504];
  private readonly maxRetries = 2;
  isChangeUserPasswordErrorDisplayed: boolean = false;
  loggedOutPopupRef: any = null;
  isLoginAsClient: boolean = false;
  isServiceUnavailable: boolean = false;
  constructor(
    private globalHandler: GlobalErrorHandler,
    private clientDetailService: ClientDetailService,
    private authService: AuthService,
    private broadCastService: BroadcastService,
    private msgService: MessageService,
    private userService: UserService,
    private sessionExpiredService: SessionExpiredService,
    private router: Router,
    private loaderService: LoaderService
  ) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  
    return next.handle(req).pipe(
      // retry() replaces deprecated retryWhen() and caps re-subscriptions to two attempts.
      retry({
        count: this.maxRetries,
        delay: (retryError, retryCount) => {
          // Retry only transient network/server errors; propagate all other errors immediately.
          if (!this.retryableStatuses.includes(retryError?.status)) {
            return throwError(() => retryError);
          }

          // Keep the loader visible during the retry delay and back off between attempts.
          this.loaderService.showLoader();
          return timer(retryCount === 1 ? 300 : 800);
        }
      }),
      tap({
        // A successful response means the service is available again.
        next: (response) => {
          if (response instanceof HttpResponse) {
            if (this.isServiceUnavailable) {
              this.isServiceUnavailable = false;
              this.broadCastService.broadcast(MsgConstantConfig.SERVICE_UNAVAILABLE, false);
            }
          }
        },
        // Handle and report the final error after retries are exhausted or skipped.
        error: (error) => {
          // Stop the retry loader when the request will not be retried further.
          this.loaderService.hideLoader();

          console.log("error", error);
          const slug = this.clientDetailService.CLIENT_ID;
          const isAuthenticated = this.authService.isAuthenticated();
          const status = error?.status ?? '';
          const url = !isAuthenticated ? `/${slug}` : `/${slug}/landing`;

          if (error?.error?.code === 'CLIENT_ACCESS_BLOCKED') {
            this.broadCastService.broadcast(MsgConstantConfig.CLIENT_ACCESS_BLOCKED, error.error);
            if (error.error.message) {
              error.error.message = '';
            }
            this.globalHandler.logError(error);
          }
          if (status !== 0 && status !== 503 && this.isServiceUnavailable) {
            setTimeout(() => {
              this.isServiceUnavailable = false;
              this.broadCastService.broadcast(MsgConstantConfig.SERVICE_UNAVAILABLE, false);
            });
          }
          switch (status) {
            case 404:
              if(!error?.url?.includes("amazonaws")){
                this.router.navigate([`${url}/error-404?fp=${(isAuthenticated ? 'H' : 'F')}`],{ replaceUrl: true })
              }
              // this.msgService.showError(error?.error?.message);
              break;
            case 403:
              if (this.clientDetailService.highSeverityLock) {
                break;
              }
              window.location.href = `${url}/error-403?fp=${(isAuthenticated ? 'H' : 'F')}`;//for no access page
              break;
            // case 503://for local service unavailable
            case 0://for dev service unavailable
              this.isServiceUnavailable = true;
              console.log("this.isServiceUnavailable", this.isServiceUnavailable);
              this.broadCastService.broadcast(MsgConstantConfig.SERVICE_UNAVAILABLE, true);
              break;
            case 400:
              if (error?.error?.maintenance_mode == "ON") {
                if (this.clientDetailService.highSeverityLock) {
                  if(error?.error?.message) {
                    error.error.message = '';
                  }
                  break;
                }
                this.isServiceUnavailable = true;
                this.broadCastService.broadcast(MsgConstantConfig.MAINTENANCE);
                if(error?.error?.message) {
                  error.error.message = '';
                }
              }
              break;
            case 401:
              if (this.clientDetailService.highSeverityLock) {
                break;
              }
              this.isLoginAsClient = this.userService.getLoginType(this.clientDetailService?.clientDetail?.slug);
              if (error?.error?.error === "password_expired") {
                if (error?.error?.message && this.isChangeUserPasswordErrorDisplayed == false) {
                  this.isChangeUserPasswordErrorDisplayed = true;
                  this.msgService.showError(error?.error?.message);
                }


                  this.broadCastService.broadcast(MsgConstantConfig.CHANGE_USER_PASSWORD);
                }

                else if (this.authService.isAuthenticated()) {
                  if (this.isLoginAsClient) {
                    this.sessionExpiredService.showPopup();
                  } else {
                    this.broadCastService.broadcast(MsgConstantConfig.AUTH_TOKEN_EXPIRED);
                  }
                }
                else if (!this.authService.isAuthenticated() && error?.url !== PathConfig.USER_ME && error?.url !== PathConfig.AUTH_LOGIN_LOGOUT && !this.loggedOutPopupRef) {
                  if (!this.isLoginAsClient) {
                    window.location.reload();// NOT login as client → reload
                  } else if (!error?.url?.includes('unread_count') && !error?.url?.includes('loan_details')) {
                    this.sessionExpiredService.showPopup();
                  }
                }
                else
                  break;
            }

          // verify for expired token
          if (this.authService.isAuthenticated() && this.authService.isTokenExpired() && !this.isServiceUnavailable) {
            if (this.isLoginAsClient) {
              this.sessionExpiredService.showPopup();
            } else {
              this.broadCastService.broadcast(MsgConstantConfig.AUTH_TOKEN_EXPIRED);
            }
          }
          //global error handler
          this.globalHandler.logError(error);
        }
      })
    );
  }

}

